export default {
  namespaced: true,
  state: {
    isReconnect: false // 是否ws重连， 场景一：如果恢复网络后重连，自动刷新页面
  },
  getters: {},
  mutations: {
    setIsReconnect(state, payload) {
      state.isReconnect = payload;
    }
  }
};
